"use client";

import React, { useEffect, useState, Suspense, lazy } from "react";
import { Box, Typography } from "@mui/material";

const Chart = lazy(() => import("react-apexcharts"));

const EngagementGrowth = ({ conversationData = [] }) => {
  const [isChartLoaded, setChartLoaded] = useState(false);

  useEffect(() => {
    setChartLoaded(true);
  }, []);

  // Extract conversation data for line chart
  const conversationMonths = (conversationData || []).map(item => item.month_label || 'Unknown');
  const conversationCounts = (conversationData || []).map(item => item.total_conversations || 0);

  // Line Chart Data - using actual conversation data
  const lineOptions = {
    chart: { type: 'line', toolbar: { show: false } },
    stroke: { curve: 'smooth', width: 3 },
    colors: ['#605DFF'],
    xaxis: {
      categories: conversationMonths.length > 0 ? conversationMonths : ['No Data'],
      labels: { style: { colors: '#64748B' } }
    },
    yaxis: {
      labels: { style: { colors: '#64748B' } }
    },
    grid: { borderColor: '#ECEEF2' }
  };

  const lineSeries = [{
    name: 'Conversations',
    data: conversationCounts.length > 0 ? conversationCounts : [0]
  }];

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} mb={2} className="text-black">
        Conversations Over Time
      </Typography>
      <Box sx={{ height: 300 }}>
        {isChartLoaded && (
          <Suspense fallback={<div>Loading...</div>}>
            <Chart options={lineOptions} series={lineSeries} type="line" height={300} />
          </Suspense>
        )}
      </Box>
    </Box>
  );
};

export default EngagementGrowth;